import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AuthClientConfig } from '@auth0/auth0-angular';
import { EMPTY, catchError, tap } from 'rxjs';
import { APP_CONFIG, AppConfig } from '@app/core/app-config';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(
    private clientConfig: AuthClientConfig,
    @Inject(APP_CONFIG) private appConfig: AppConfig,
  ) {}

  get<K extends keyof AppConfig>(key: K) {
    return this.appConfig[key];
  }

  initializeAuth0(http: HttpClient) {
    if (this.appConfig.auth0ClientId) {
      this.setAuth0ClientConfig();
      return EMPTY;
    } else {
      return http
        .get<any>(`${this.appConfig.accountsApiUrl}/clients/home-realm`, {
          params: {
            product: 'ERP',
            subdomain: this.appConfig.auth0Subdomain,
          },
        })
        .pipe(
          catchError(() => {
            this.setAuth0ClientConfig();
            return EMPTY;
          }),
          tap((client) => {
            this.appConfig.auth0ClientId = client.clientId;
            this.setAuth0ClientConfig();
          }),
        );
    }
  }

  private setAuth0ClientConfig() {
    this.clientConfig.set({
      clientId: this.appConfig.auth0ClientId,
      domain: this.appConfig.auth0Domain,
      // Top-level AuthConfig options -- must not be nested inside
      // `authorizationParams` (see the note in main.ts).
      useRefreshTokens: true,
      useRefreshTokensFallback: false,
      cacheLocation: 'localstorage',
      authorizationParams: {
        redirect_uri: window.location.href,
        audience: this.appConfig.auth0Audience,
        scope: this.appConfig.auth0Scope,
        auth_ctx: JSON.stringify({
          tenant_id: this.appConfig.tenantId,
        }),
      },
    });
  }
}
